import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { api, type SourceSummary, type SourceGroup } from '../lib/api';

/** Liste live des sources ingérées (SharePoint / Teams / Web). Partagée par le
 *  disclaimer et l'aide — toujours fidèle à ce qui est réellement en base. */
export function DataSources() {
  const { t, i18n } = useTranslation();
  const [data, setData] = useState<SourceSummary | null>(null);

  useEffect(() => {
    void api
      .sources()
      .then(setData)
      .catch(() => setData(null));
  }, []);

  if (!data) return <p className="text-sm text-muted">{t('dataSources.loading')}</p>;
  if (data.totals.docs === 0) return <p className="text-sm text-muted">{t('dataSources.empty')}</p>;

  const nf = (n: number): string => n.toLocaleString(i18n.language === 'de' ? 'de-CH' : 'fr-CH');
  const groups: Array<[string, SourceGroup[]]> = [
    ['sharepoint', data.sharepoint],
    ['teams', data.teams],
    ['web', data.web],
  ];

  return (
    <div className="space-y-3">
      <p className="text-xs text-muted">
        {t('dataSources.totals', { docs: nf(data.totals.docs), grains: nf(data.totals.grains) })}
      </p>
      {groups.map(([key, list]) =>
        list.length === 0 ? null : (
          <div key={key}>
            <p className="mb-1 text-xs font-semibold uppercase tracking-wide text-muted">{t(`dataSources.${key}`)}</p>
            <div className="flex flex-wrap gap-1.5">
              {list.map((g) => (
                <span key={g.name} className="inline-flex items-center gap-1 rounded-full bg-surface-2 px-2 py-0.5 text-xs">
                  {g.name} <span className="text-muted">· {t('dataSources.docs', { count: g.docs })}</span>
                </span>
              ))}
            </div>
          </div>
        ),
      )}
    </div>
  );
}
